import { sha256 } from 'js-sha256';
import { CONVERSATION_ID_LENGTH } from './../../constants/dataFrame';

/**
 * Converts a hex string to a Uint8Array.
 */
function hexToBytes(hex: string): Uint8Array {
  if (hex.length % 2 !== 0) throw new Error("Invalid hex string");
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < bytes.length; ++i) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
  }
  return bytes;
}

export async function generateDeterministicConversationId({
  viewKeyA,
  viewKeyB,
}: {
  viewKeyA: Uint8Array;
  viewKeyB: Uint8Array;
}): Promise<Uint8Array> {
  const [first, second] = [viewKeyA, viewKeyB].sort((a, b) =>
    Buffer.compare(Buffer.from(a), Buffer.from(b))
  );

  const concatenated = new Uint8Array(first.length + second.length);
  concatenated.set(first);
  concatenated.set(second, first.length);

  const hashHex: string = await sha256(concatenated); // assuming string
  const fullHash = hexToBytes(hashHex);

  return fullHash.slice(0, CONVERSATION_ID_LENGTH);
}